<template>
  <div id="home">
    <my-header :page="'page_not_found'"></my-header>
    <div class="pd20" id="page-not-found">
      <p>{{'Page Not Found'|translate}}</p>
      <img src="/static/images/warning.svg" />
    </div>
    <!-- end pd20 -->
  </div>
</template>

<script>
import MyHeader from "@/components/Layout/Header";
export default {
  name: "PageNotFound",
  components: {
    MyHeader
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/Page/PageNotFound.vue